// BrandedSplash — loading state splash screen with Citycare branding.
// Reused across loading states in auth flow. Citycare brand: Cream
// background, Forest wordmark, Lime accent dot, display serif heading.

import { Spinner } from './spinner'

export interface BrandedSplashProps {
  message?: string
}

export function BrandedSplash({ message = 'Loading session…' }: BrandedSplashProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-surface pt-safe text-center">
      {/* Logo */}
      <img
        src="/icons/icon-512.png"
        alt="Citycare"
        className="h-24 w-24"
      />

      {/* Wordmark */}
      <div className="space-y-1">
        <span className="inline-flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-[color:var(--color-cc-forest)]/70">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-[color:var(--color-cc-lime)]" />
          Citycare Property
        </span>
        <h1 className="font-display text-3xl font-semibold tracking-tight text-[color:var(--color-cc-forest)]">
          Asset Capture
        </h1>
        <p className="text-sm italic text-[color:var(--color-cc-forest)]/60">
          We discover. We deliver. We care.
        </p>
      </div>

      {/* Spinner — Citycare brand colours applied automatically (W2.7). */}
      <div className="flex items-center justify-center">
        <Spinner label={message} size="lg" />
      </div>
    </div>
  )
}
